import { render, staticRenderFns } from "./materialInfo.vue?vue&type=template&id=f93c46a0&"
import script from "./materialInfo.vue?vue&type=script&lang=js&"
export * from "./materialInfo.vue?vue&type=script&lang=js&"
import style0 from "./materialInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports